import {
  SuitableCouponItem,
  TCouponItem,
} from '@/page-components/detail/Intro/Coupon/couponItem';
import { getCookie } from '@/utils';
import { TExamKind } from '@/types';
import { requestGet } from '@/services/request';
import { TApi } from '@/types/api';

// 获取优惠券
export function apiShequGetCouponList(
  type: TExamKind,
  totalPrice: any,
): Promise<
  TApi<{
    list: TCouponItem[];
    suitableCoupon: SuitableCouponItem;
  }>
> {
  const uid = getCookie('uid');
  let pid = null;
  if (type === 'fcrp' || type === 'fcrpd') {
    pid = 0;
  } else if (type === 'fcbp') {
    pid = 1;
  } else if (type === 'fcjp') {
    pid = 2;
  } else if (type === 'fcap') {
    pid = 3;
  } else if (type === 'fcp_plugin') {
    pid = 4;
  } else if (
    type === 'fcp_data_analysis' ||
    type === 'fcp_business_data_analysis'
  ) {
    pid = 5;
  }
  return requestGet('/v1/user/coupon/getCoupon', {
    pid,
    module: 3,
    uid,
    price: totalPrice,
  });
}

// 兑换优惠券
export function apiShequDoCouponChange({
  cpcode,
}: {
  cpcode: string;
}): Promise<TApi<TCouponItem>> {
  return requestGet('/v1/user/coupon/exchCoupon', { cpcode });
}
